export const STORAGE_KEYS = {
  TOKEN: 'trade.token',
  SERVER: 'trade.server',
  ACTIVE_ACCOUNT: 'iuxmarkets.active.account'
};

export const type = {
  str: {
    buy: 'Buy',
    sell: 'Sell',
    editBuyLimit: 'Buy Limit',
    editSellLimit: 'Sell Limit',
    editBuyStop: 'Buy Stop',
    editSellStop: 'Sell Stop',
    editBuyStopLimit: 'Buy Stop Limit',
    editSellStopLimit: 'Sell Stop Limit'
  }
};

export const FILTER_LIST = [
  {
    name: 'All',
    key: 6
  },
  {
    name: 'Today',
    key: 7
  },
  {
    name: 'Last Week',
    key: 0
  },
  {
    name: 'Last Month',
    key: 1
  },
  {
    name: 'Last 3 Month',
    key: 2
  },
  {
    name: 'Last 6 Month',
    key: 3
  },
  {
    name: 'Last Year',
    key: 4
  },
  {
    name: 'Custom',
    key: 5
  }
];

export const ORIGIN = {
  'http://localhost:3000': 'https://www.iux.com',
  'https://trading.iux.com': 'https://www.iux.com',
  'https://trading.iuxvn.com': 'https://www.iuxvn.com',
  'https://trading.id-iux.com': 'https://www.id-iux.com',
  'https://trading.iuxbeta.com': 'https://www.iuxbeta.com'
};

const DEFAULT_VALUES = {
  COMMENT: 'No Comment',
  ID: 0,
  PRICE: 0
};

export const createOrderObject = (orderData)  =>{
  const [
    ,
    id = DEFAULT_VALUES.ID,
    order = DEFAULT_VALUES.ID,
    symbol = '',
    digits = DEFAULT_VALUES.ID,
    contractSize = DEFAULT_VALUES.ID, // Skip unused indices
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    type, // Skip unused indices
    ,
    ,
    priceOrder,
    priceTrigger = DEFAULT_VALUES.PRICE,
    priceCurrent,
    priceSL = DEFAULT_VALUES.PRICE,
    priceTP = DEFAULT_VALUES.PRICE,
    volumeInitial = DEFAULT_VALUES.ID, // Skip unused indices
    ,
    volumeCurrent, // Skip unused indices
    ,
    comment = DEFAULT_VALUES.COMMENT, // Skip unused indices
    ,
    ,
    ,
    ,
    digitsCurrency = DEFAULT_VALUES.ID
  ] = orderData;

  return {
    id,
    order,
    symbol,
    digits,
    digitsCurrency,
    contractSize,
    type,
    priceOrder,
    priceTrigger,
    priceCurrent,
    priceSL,
    priceTP,
    volumeInitial,
    volumeCurrent,
    comment
  };
}

export const POSITION_MAPPING = {
  position: 1,
  symbol: 2,
  action: 3,
  digits: 4,
  digits_currency: 5,
  contract_size: 6,
  time_create: 7,
  time_update: 8,
  price_open: 9,
  price_current: 10,
  price_sl: 11,
  price_tp: 12,
  volume: 13,
  profit: 14,
  reason: 15,
  swap: 16,
  rate_profit: 17
};
export const ORDER_MAPPING = {
  position_id: 1,
  order: 2,
  login: 3,
  symbol: 4,
  digits: 5,
  digis_currency: 31,
  contract_size: 6,
  state: 7,
  reason: 8,
  time_setup: 9,
  time_setup_msc: 10,
  time_expiration: 11,
  time_done: 12,
  time_done_msc: 13,
  type: 14,
  type_fill: 15,
  type_time: 16,
  price_order: 17,
  price_trigger: 18,
  price_current: 19,
  price_sl: 20,
  price_tp: 21,
  volume_initial: 22,
  volume_initial_ext: 23,
  volume_current: 24,
  volume_current_ext: 25,
  comment: 26,
  activation_mode: 27,
  activation_time: 28,
  activation_price: 29,
  activation_flags: 30
}

export const TIME_UNITS = {
  SECONDS_PER_DAY: 24 * 60 * 60,
  SECONDS_PER_HOUR: 60 * 60,
  SECONDS_PER_MINUTE: 60,
  MAX_DAYS_BACK: 3650, // 10 years
  DAYS_SHIFT: 5,
};

export const RESOLUTION_CONFIG = {
  DAILY: 'D',
  WEEKLY: 'W',
  MONTHLY: 'M',
};